<div class="wrapper d-flex flex-direction-column">
  <ng-container *ngIf="showMainImage">
    <label fbDragDropFile (fileDropped)="onSelectImage($event)" class="main-image cursor-pointer" *ngIf="mainImage">
      <input hidden type="file" name="file" accept="image/*" (change)="onSelectImage($event.target)" />
      <img class="image" [src]="mainImage | fileToBase64Async | async" alt="" />
      <img class="image-placeholder" [src]="mainImage | fileToBase64Async | async" alt="" />
    </label>

    <label
      *ngIf="!mainImage"
      class="main-image main-image-placeholder"
      fbDragDropFile
      (fileDropped)="onSelectImage($event)"
    >
      <input hidden type="file" name="file" accept="image/*" (change)="onSelectImage($event.target)" />

      <div class="icon"></div>
      <div class="flex flex-direction-column px-8">
        <div class="t-footnote-regular d-flex">
          <div class="green t-footnote-semibold">Browse</div>
          &nbsp; or drag and drop vehicle image
        </div>
        <div class="t-caption-regular text-align-center grey">SVG, PNG, JPG or GIF (max. 800x400px)</div>
      </div>
    </label>
  </ng-container>

  <form class="slider" [formGroup]="form" *ngIf="showSlider">
    <div
      class="slide"
      *ngFor="let _ of [].constructor(numberOfImages || 10); let i = index"
      [style.width]="slideWidth || '80px'"
      [style.min-width]="slideWidth || '80px'"
    >
      <ng-container *ngIf="i < formArray.controls.length; else emptyControl">
        <div class="preview" (click)="mainImage = formArray.controls[i].value">
          <ng-container *ngIf="formArray.controls[i].value | fileToBase64Async | async as imageSrc">
            <img class="image-placeholder" [src]="imageSrc" alt="slider-image-placeholder" />
            <img class="image" [src]="imageSrc" alt="slider-image" />
          </ng-container>
        </div>
        <label class="icon-wrapper remove" matRipple (click)="onRemove(i); $event.preventDefault()">
          <input hidden type="file" name="file" accept="image/*" (change)="onSelectImage($event.target, i)" />
          <mat-icon>close</mat-icon>
        </label>
      </ng-container>

      <ng-template #emptyControl>
        <label class="icon-wrapper add" matRipple>
          <input
            hidden
            type="file"
            #dropInput
            name="file"
            accept="image/*"
            (change)="onSelectImage($event.target, i)"
          />
          <mat-icon>close</mat-icon>
        </label>
      </ng-template>
    </div>
  </form>
</div>
